/**
 * Users — typeahead search over cc_sec_users.display_name.
 */

import type { UserSearchResult } from '@/types/user'
import { DEFAULT_USER_SEARCH_LIMIT } from '@/services/api-constants'
import { apiClient } from './client'

export const users = {
  search: async (
    q: string,
    opts: { limit?: number } = {}
  ): Promise<UserSearchResult[]> => {
    const response = await apiClient.get<UserSearchResult[]>('/api/v1/users/', {
      params: { q, limit: opts.limit ?? DEFAULT_USER_SEARCH_LIMIT },
    })
    return response.data
  },
}
